/* istanbul ignore file */

import type { ChangeEvent } from 'react';
import React from 'react';
import { RadioDial } from '@noths/polaris-client-ribbons-design-system';

import * as styles from './RadioButton.styles';

/** @deprecated do not interfere with RadioButton's styles from outside **/
export const classNames = {
  RADIO_BUTTON__LABEL_CLASS: 'radio_button__label',
  RADIO_BUTTON__LABEL_TEXT_CLASS: 'radio_button__label-text',
};

export type RadioButtonProps = {
  labelText: string;
  name?: string;
  value: string;
  checked?: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

export const RadioButton = ({
  labelText,
  name,
  value,
  checked = false,
  onChange,
}: RadioButtonProps) => (
  <label css={styles.radioButtonWrapper} className={classNames.RADIO_BUTTON__LABEL_CLASS}>
    <RadioDial
      name={name}
      value={value}
      checked={checked}
      onChange={onChange}
      aria-label={labelText}
    />
    <span
      css={styles.radioButtonLabelText}
      className={classNames.RADIO_BUTTON__LABEL_TEXT_CLASS}
      aria-hidden="true"
    >
      {labelText}
    </span>
  </label>
);
